var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8029 20.7144H6.75419C6.09274 20.7144 5.55664 20.1783 5.55664 19.5169C5.55664 18.8554 6.09274 18.3193 6.75419 18.3193H22.8025C23.4639 18.3193 24 18.8554 24 19.5169C24 20.1783 23.4643 20.7144 22.8029 20.7144Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8029 13.1973H6.75419C6.09274 13.1973 5.55664 12.6612 5.55664 11.9998C5.55664 11.3383 6.09274 10.8022 6.75419 10.8022H22.8025C23.4639 10.8022 24 11.3383 24 11.9998C24.0004 12.6612 23.4643 13.1973 22.8029 13.1973Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8029 5.68073H6.75419C6.09274 5.68073 5.55664 5.14463 5.55664 4.48319C5.55664 3.82175 6.09274 3.28564 6.75419 3.28564H22.8025C23.4639 3.28564 24 3.82175 24 4.48319C24 5.14463 23.4643 5.68073 22.8029 5.68073Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6083 6.18389C2.49654 6.18389 3.21661 5.46383 3.21661 4.57559C3.21661 3.68735 2.49654 2.96729 1.6083 2.96729C0.720062 2.96729 0 3.68735 0 4.57559C0 5.46383 0.720062 6.18389 1.6083 6.18389Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6083 13.6082C2.49654 13.6082 3.21661 12.8881 3.21661 11.9999C3.21661 11.1117 2.49654 10.3916 1.6083 10.3916C0.720062 10.3916 0 11.1117 0 11.9999C0 12.8881 0.720062 13.6082 1.6083 13.6082Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6083 21.0325C2.49654 21.0325 3.21661 20.3125 3.21661 19.4242C3.21661 18.536 2.49654 17.8159 1.6083 17.8159C0.720062 17.8159 0 18.536 0 19.4242C0 20.3125 0.720062 21.0325 1.6083 21.0325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.3483d5bf72bd8d619fcdee2e6992b4b6.svg";
export { ForwardRef as ReactComponent };